import { IS_DEV_STAGE, IS_PROD_STAGE, SDK_TOKEN } from '@/js/constants';

export const isPeachJohn = () => {
  // [日本維運] 協助商店 PEACHJOHN (shop ID 15868) 設為原頁跳轉
  // jira: https://17media.atlassian.net/browse/HU-9571
  // slack: https://17media.slack.com/archives/C0150TSS8TX/p1770266552883679 

  return (IS_PROD_STAGE && SDK_TOKEN === 'q6ory5l6') ||

    // slug: `blairleestore`
    (IS_DEV_STAGE && SDK_TOKEN === '9jwrzq64');
};
